<script setup>
/**
 * Aviso permanente de que voce nao esta na sua conta.
 *
 * POR QUE FIXA NO TOPO, e nao um toast. Quem personifica esquece. A tela
 * inteira passa a ser a de outra pessoa -- menu, permissoes, dados -- e sem um
 * aviso que nao sai da frente, a proxima acao e feita achando que e a propria
 * conta. O custo de ocupar uma faixa e menor do que o de alguem operar em nome
 * de outro sem perceber.
 *
 * Aparece em TODAS as telas porque vive no App, nao numa pagina: personificar
 * e um estado da sessao, nao de uma tela.
 */
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import message from '@/services/messages.js';
import { handleError } from '@/utils/errors';
import { atorAtual, voltarParaMim } from '@/services/personificacao.js';

const { t } = useI18n();

const ator = ref(atorAtual());
const voltando = ref(false);

async function voltar() {
    try {
        voltando.value = true;
        await voltarParaMim();

        // Recarga inteira, pelo mesmo motivo de entrar: identidade nova
        // significa permissao, menu e empresa novos, e o estado montado ficaria
        // com os antigos.
        window.location.href = '/perfil';
    } catch (error) {
        voltando.value = false;
        message.error(await handleError(error.response ?? error, t));
    }
}

defineOptions({ name: 'FaixaPersonificacao' });
</script>

<template>
    <div v-if="ator" class="faixa-personificacao">
        <span>
            {{ t('components.users.personificar.faixa', { ator }) }}
        </span>
        <button type="button" :disabled="voltando" @click="voltar">
            {{ voltando ? t('components.users.personificar.voltando') : t('components.users.personificar.voltar') }}
        </button>
    </div>
</template>

<style scoped>
/*
 * Amarelo de atencao, e nao vermelho: nao e erro, e um estado incomum que
 * precisa ser notado. Texto escuro sobre amarelo mantem o contraste legivel.
 */
.faixa-personificacao {
    position: sticky;
    top: 0;
    z-index: 1100;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 8px 16px;
    background: #ffcb05;
    color: #1f2937;
    font-weight: 600;
    font-size: 14px;
}

.faixa-personificacao button {
    background: #1f2937;
    color: #fff;
    border: 0;
    border-radius: 4px;
    padding: 4px 12px;
    font-weight: 600;
    cursor: pointer;
}

.faixa-personificacao button:disabled {
    opacity: 0.6;
    cursor: default;
}
</style>
